export default __webpack_public_path__ + "assets/models/72c7cde65ac0906c89ed13657272934b.glb";